
if (!customElements.get('layout-grid-and-list')){
    customElements.define('layout-grid-and-list', class layoutGridAndList extends HTMLElement {
      constructor() {
        super();
        this.addToCartBtn = this.querySelector('button[name="bulk-add"]');
        this.gridBtn = this.querySelector('button[name="control-grid"]');
        this.listBtn = this.querySelector('button[name="control-list"]');
        this.layout = "list";
      }
      
      connectedCallback() {
        // Listen to button click
        this.addToCartBtn?.addEventListener('click', (e) => {
          e.preventDefault();
          
          const productsToCart = this.checkItems();
          
          if (productsToCart.length > 0) {
            this.handleAddToCart(productsToCart);
          }
        });
  
        this.gridBtn.addEventListener("click", this.viewGrid.bind(this));
        this.listBtn.addEventListener("click", this.viewList.bind(this))
      }
  
      updateView(){
        if(this.layout == 'grid'){
          this.viewGrid();
        }else if(this.layout == 'list'){
          this.viewList();
        }
      }
      
      viewGrid() {
        const gridView = document.querySelector('#product-grid');
        this.gridBtn.classList.add('active');
        gridView?.classList.remove('hidden');
  
        const listView = document.querySelector('#product-list');
        this.listBtn.classList.remove('active');
        listView?.classList.add('hidden');
        this.addToCartBtn?.classList.add('hidden','disabled');
        this.layout = "grid";
      }
  
      viewList() {
        const listView = document.querySelector('#product-list');
        this.listBtn.classList.add('active');
        listView.classList.remove('hidden');
  
        const gridView = document.querySelector('#product-grid');
        this.gridBtn.classList.remove('active');
        gridView.classList.add('hidden');
        this.addToCartBtn?.classList.remove('hidden', 'disabled');
        this.layout = "list";
      }
  
      checkItems() {
        const listView = document.querySelector('#product-list');
        if(!listView) return;
        const rows = listView.querySelectorAll("quantity-with-buttons");
        const productsToBeAdded = [];
        for (const row of rows) {
          const productQuantity = row.querySelector(".quantity__input").value;
          const variantID = row.getAttribute("data-variant-id");
  
          if (parseInt(productQuantity) > 0) {
            productsToBeAdded.push({ id: variantID, quantity: productQuantity });
          } 
        }
        return productsToBeAdded; 
      }
      
      clearUpQuantityFields(){
        const listView = document.querySelector('#product-list');
        if(!listView) return;
          const rows = listView.querySelectorAll("quantity-with-buttons");
          for (const row of rows) {
              row.clearField();
          }
      }
  
      async handleAddToCart(products) {
        this.addToCartBtn?.classList.add('disabled', 'loading');
        this.addToCartBtn?.setAttribute('aria-disabled', true);
  
        const sections = this.getSectionsToRender().map((section) => section.section);
  
        let formData = {
          'items': products,
          "sections": sections
        };
      
        fetch(`${routes.cart_add_url}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then((response) => {
          if (response.status) {
            console.error(response.description);
            return;
          }
  
          const miniCart = document.querySelector("mini-cart");
          if (miniCart) {
            miniCart.renderContents(response);
            this.clearUpQuantityFields();
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.addToCartBtn?.classList.remove('disabled', 'loading');
          this.addToCartBtn?.setAttribute('aria-disabled', false);
        });
      }
  
      getSectionsToRender() {
        return [
          {
            id: 'mini-cart',
            section: 'mini-cart',
            selector: '.shopify-section'
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section'
          },
          {
            id: 'cart-live-region-text',
            section: 'cart-live-region-text',
            selector: '.shopify-section'
          }
        ];
      }
  })
  }